import { createContext, useEffect, useState } from "react";
import {PRODUCTS} from "../product";

// Create a context for the shop
export const ShopContext = createContext(null);

// Function to get default cart items
const getDefaultCart = () => {
  let cart = {};
  for (let i = 1; i < PRODUCTS.length + 1; i++) { 
    cart[i]=0; 
  } 
  return cart; 
};

// Shop Context Provider component
export const ShopContextProvider = (props) => {
  // State for cart items and favorite items
  const [cartItems, setCartItems] = useState(getDefaultCart());
  const [favoriteItems, setFavoriteItems, ] = useState([]);

  // Function to get total amount in the cart
  const getTotalCartAmount = () => {
    let totalAmount = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        let itemInfo = PRODUCTS.find((product) => product.id === Number(item));
        totalAmount += cartItems[item] * itemInfo.price;
      }
    }
    return totalAmount;
  };

  // Function to get total count of items in the cart
  const getTotalCartCount = () => {
    let totalCount = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        totalCount += cartItems[item];
      }
    }
    return totalCount;
  };

  // Function to add an item to favorites
  const addToFavorites = (itemId) => {
    setFavoriteItems((prev) => [...prev, itemId]);
  };

  // Function to remove an item from favorites
  const removeFromFavorites = (itemId) => {
    setFavoriteItems((prev) => prev.filter((id) => id !== itemId));
  };

  // Function to check if an item is in favorites
  const isItemInFavorites = (itemId) => favoriteItems.includes(itemId);

  // Function to add an item to the cart
  const addToCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
  };

  // Function to remove an item from the cart
  const removeFromCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
  };

  // Function to update the count of an item in the cart
  const updateCartItemCount = (newAmount , itemId) => {
    setCartItems ((prev) => ({...prev, [itemId]: newAmount}));
  }

  // Define the context value with all the functions and state
  const contextValue = {
    cartItems,
    addToCart,
    removeFromCart,
    updateCartItemCount,
    getTotalCartAmount,
    favoriteItems,
    addToFavorites,
    removeFromFavorites,
    isItemInFavorites,
    getTotalCartCount,
  };

  // Provide the context value to the children components
  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};
